import { render, staticRenderFns } from "./UserReports.vue?vue&type=template&id=8f23accc&scoped=true"
import script from "./UserReports.vue?vue&type=script&lang=js"
export * from "./UserReports.vue?vue&type=script&lang=js"
import style0 from "./UserReports.vue?vue&type=style&index=0&id=8f23accc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f23accc",
  null
  
)

export default component.exports